import React, { useContext } from "react";
import { useParams, Link } from "react-router-dom";
import File from "./File";
import UploadFiles3 from "./UploadFiles3";
import { Card, Button, Grid } from "@mui/material";
import { useUserProvider } from "../context/UserProvider";

import { useSiteProvider } from "../context/SiteProvider";

const Files = ({ files, onCreate, siteRef }) => {
  const { user } = useUserProvider();
  const { sites } = useSiteProvider();
  // console.log();
  return (
    <>
      {!user ? (
        <Link to="/login" style={{ textDecoration: "none" }}>
          <Button
            component="a"
            // endIcon={<EditIcon fontSize="small" />}
            sx={{ mt: 2 }}
            variant="outlined"
            size="small"
          >
            Sign in to access documents
          </Button>
        </Link>
      ) : (
        <>
          {files?.map((file) => (
            <File
              {...file}
              {...user}
              key={file.createAt}
              caption={file.caption}
              images={file.images}
            />
          ))}

          <UploadFiles3 onCreate={onCreate} siteRef={siteRef} />
        </>
      )}
    </>
  );
};

export default Files;
